import { telemetryService } from 'npo-common';
import { appSettings } from 'src/common/configuration/appSettings';

telemetryService.setContext({
  Environment: appSettings.environmentStr,
  Scs: appSettings.scs,
  ServiceName: appSettings.serviceName,
  ServiceRegion: appSettings.serviceRegion,
  ServiceVersion: appSettings.serviceVersion,
  ServiceId: appSettings.serviceId,
  ServiceType: appSettings.serviceType
});

try {
  // No history: BrowserRouter owns its own instance, so navigation page views come from automatic route tracking.
  telemetryService.initialize().trackPageView({ uri: window.location.pathname });
} catch {
  // initialize() already logged the error; telemetry failure must not block rendering.
}
